//#region src/logic/reconcilePasskey.ts
var e = 2e3, t = 3e4, n = async (t, { reconcile: n, sleep: r, now: i }) => {
	let a = i();
	for (;;) {
		await r(e);
		let o;
		try {
			o = await n(t);
		} catch {
			return { kind: "refused" };
		}
		if (!("state" in o)) return {
			kind: "resolved",
			response: o
		};
		if (i() - a >= 3e4) return { kind: "timeout" };
	}
};
//#endregion
export { e as RECONCILE_INTERVAL_MS, t as RECONCILE_TIMEOUT_MS, n as pollPasskeyReconcile };
